module.exports = __webpack_public_path__ + "static/media/SR105-W1-P5 Copy.19eb235d.png";